// getAPNG.js
'use strict';
import parseAPNG, { isNotAPNG } from 'apng-js';

import { getHeaders } from '../resource/fetchOptionHeader.js';
import responseDecryptionUtil from '../resource/responseDecryptionUtil.js';

import env from './env.js';

/**
 * @typedef {Object} APNG
 * @property {boolean} isAPNG - is APNG format or not
 * @property {Object} apng - Structure of APNG file
 */

/**
 * Get APNG
 * @param {string} {imageSource} - image source to fetch.
 * @return {Promise.<APNG>} return APNG object.
 */
async function getAPNG({ imageSource }) {
  if (!imageSource) {
    return {
      isAPNG: false,
      apng: null,
    };
  }

  try {
    let imageArrayBuffer;
    const fetchOptions = {
      method: 'GET',
      headers: getHeaders(),
    };
    const isDecryptionRequired = env.FEATURE_RESOURCE_DECRYPTION;

    if (isDecryptionRequired) {
      const encryptedImageSource = imageSource.replace(
        env.PUBLIC_URL_PREFIX,
        env.PUBLIC_ENCRYPTED_URL_PREFIX
      );
      const response = await fetch(encryptedImageSource, fetchOptions);
      const decrypted = await responseDecryptionUtil({ response });
      imageArrayBuffer = decrypted.buffer;
    } else {
      const giftImageSrc = await fetch(imageSource, fetchOptions);
      imageArrayBuffer = await giftImageSrc.arrayBuffer();
    }

    const apng = parseAPNG(imageArrayBuffer);
    if (isNotAPNG(apng)) {
      return {
        isAPNG: false,
        apng: null,
      };
    }
    return {
      isAPNG: true,
      apng,
    };
  } catch (error) {
    return {
      isAPNG: false,
      apng: null,
    };
  }
}

export default getAPNG;
